import React, { useEffect, useState } from "react";
import { errorMessage } from "../../services";
import { getBranding, resetBranding, uploadBranding } from "../../services/branding";
import { MAX_IMAGE_BYTES } from "../../services/media";
import { DEFAULT_LOGOS, setBranding } from "../../utils/branding";
import { Spinner } from "../../components/Loader";

const SLOTS = [
  { kind: "logoWide", title: "Logo with name", help: "Headers of ownezzy.com and this panel, and the sign-up popup on demo stores. A wide image, about 900 × 200." },
  { kind: "logo", title: "Round logo", help: "The phone header, demo store headers and app icons. A square image, at least 192 × 192." },
  { kind: "favicon", title: "Browser-tab icon", help: "The small icon in browser tabs. A square image; simple shapes read best at small sizes." },
];

// Super Admin -> Settings: Ownezzy's own logos, used on ownezzy.com, in the admin panel and on the demo stores.
// Sellers' stores never show them.
export default function BrandingEditor({ notify }) {
  const [branding, setState] = useState(null);
  const [busy, setBusy] = useState("");

  useEffect(() => {
    getBranding()
      .then(({ data }) => setState(data.branding))
      .catch((err) => notify(errorMessage(err), "error"));
  }, [notify]);

  const apply = (data, message) => {
    setState(data.branding);
    setBranding(data.branding); // the panel's own header and tab icon update straight away
    notify(message);
  };

  const upload = (kind) => async (e) => {
    const file = e.target.files && e.target.files[0];
    e.target.value = "";
    if (!file) return;
    if (!file.type.startsWith("image/")) return notify("Choose an image file.", "warn");
    if (file.size > MAX_IMAGE_BYTES) return notify("The image must be 2 MB or smaller.", "warn");
    setBusy(kind);
    try {
      apply((await uploadBranding(kind, file)).data, "Logo updated. ownezzy.com and the demo stores show it within a few minutes.");
    } catch (err) {
      notify(errorMessage(err, "Upload failed."), "error");
    } finally {
      setBusy("");
    }
  };

  const reset = (kind) => async () => {
    setBusy(kind);
    try {
      apply((await resetBranding(kind)).data, "Back to the original logo.");
    } catch (err) {
      notify(errorMessage(err), "error");
    } finally {
      setBusy("");
    }
  };

  return (
    <div className="panel info-panel tab-gap">
      <h2>Ownezzy logos</h2>
      <p>Shown on ownezzy.com, in this admin panel and on Ownezzy's demo stores. Sellers' stores use their own logo.</p>
      <div className="brand-slots">
        {SLOTS.map((slot) => {
          const custom = branding && branding[slot.kind];
          return (
            <div className="brand-slot" key={slot.kind}>
              <b>{slot.title}{custom && <span className="brand-slot-tag">Custom</span>}</b>
              <small>{slot.help}</small>
              <div className="brand-slot-preview"><img src={custom || DEFAULT_LOGOS[slot.kind]} alt={slot.title} /></div>
              <div className="brand-slot-actions">
                <label className="primary-btn">
                  {busy === slot.kind ? <><Spinner /> Saving</> : "Upload new"}
                  <input type="file" accept="image/jpeg,image/png,image/webp" onChange={upload(slot.kind)} disabled={Boolean(busy)} aria-label={`Upload ${slot.title}`} />
                </label>
                {custom && <button className="outline-btn" onClick={reset(slot.kind)} disabled={Boolean(busy)}>Use original</button>}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
